import { render, staticRenderFns } from "./LeaveCalendarSummary.vue?vue&type=template&id=c6aa0fe8"
import script from "./LeaveCalendarSummary.vue?vue&type=script&lang=js"
export * from "./LeaveCalendarSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports